import { RootState } from "@/redux/store";

export const selectViewAsProvider = (state: RootState) => state.faView.viewAsProvider;
